module.exports = __webpack_public_path__ + "page/img/background.3777639.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background.jpg
// module id = IIox
// module chunks = 1